<app-toolbar [showSearch]="true" [showPublications]="true"></app-toolbar>
<div class="wrapper">
  <app-sidebar></app-sidebar>
  <div class="content-primary">
    <app-modal-lock>
      <router-outlet></router-outlet>
    </app-modal-lock>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/layout/layout-dashboard/layout-dashboard.component.html